/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/committeList.config.json";
import member from "../config/memberDetail.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { GET_COMMITTE_LIST } from "../graphql";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICommitteListMethods extends IPluginMethodMap {
  getcommitteListProps(args: any): Promise<any>;
}

export class CommitteListService implements IAgentPlugin {
  readonly methods: ICommitteListMethods;

  constructor() {
    this.methods = {
      getcommitteListProps: this.getcommitteListProps.bind(this),
    };
  }

  async getcommitteListProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const filter = args.id
      ? {
          user: {
            eq: args.id,
          },
        }
      : {};

    try {
      if (client) {
        const res = await client.query({
          query: GET_COMMITTE_LIST,
          variables: {
            filter: filter,
            limit: args?.size ?? 10,
            skip: args?.offset ?? 0,
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          let result = res?.data?.getAllCommitteInviteStatus?.content;
          // console.log("res_data==>", pretty(result));
          const rows = this.formatUserTable(result);
          console.log("formatted==>", pretty(rows));
          let _totalPages = result?.count
            ? Math.ceil(parseInt(result?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getPresentations?.skip /
              res?.data?.getPresentations?.limit +
            1;
          return {
            ...config,
            ...member,
            ultUsers: rows,
            isEmpty: rows.length <= 0,
            activePage: _currentPage,
            pageSize: res?.data?.getPresentations?.limit,
            totalCount: rows.length,
            totalPages: _totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      let _display_message =
      err?.graphQLErrors &&
      Array.isArray(err?.graphQLErrors) &&
      err?.graphQLErrors.find((item: any) => item.extensions);
    if (_display_message?.extensions?.display_message) {
      throw Error(_display_message?.extensions?.display_message);
    }

    throw err;
    }
    return { ...(config || {}) };
  }

  private formatUserTable(result: any) {
    let id: any[] = [];
    result.forEach((element) => {
      id.push(element?.user?.id);
    });
    let rows: any[] = [];
    const uniqueId = Array.from(new Set(id));
    let count = 0;
    uniqueId.forEach((uid: string) => {
      let arr: any[] = [];
      result.forEach((item: any) => {
        if (item?.user?.id === uid) {
          arr.push(item);
        }
      });
      let data: any[] = [];
      let collection: any[] = [];
      let maxInvites = 0,
        inviteUsed = 0,
        purchased = 0;
      data.push({
        _id:arr[0]?.id ?? "-",
        id: arr[0]?.user?.id ?? "-",
        firstName: arr[0]?.user?.firstName ?? "null",
        surname: arr[0]?.user?.lastName ?? "null",
        fullName:
          (arr[0]?.user?.firstName ?? "null") + " " +
          (arr[0]?.user?.lastName ?? "null"),
        email: arr[0]?.user?.email ?? "null",
        roles: arr[0]?.user?.role ?? [],
        // presentation: arr[0]?.presentation?.name ?? "-",
      });
      arr.forEach((item) => {
        maxInvites += item?.maxInvites ?? 0;
        inviteUsed += item?.inviteUsed ?? 0;
        purchased += item?.purchased ?? 0;
        let remaining = (item?.maxInvites ?? 0) - (item?.inviteUsed ?? 0);
        collection.push({
          maxInvites: item?.maxInvites ?? 0,
          inviteUsed: item?.inviteUsed ?? 0,
          partition: item?.partition ?? 0,
          sectionOptType: item?.sectionOptType ?? "-",
          sectionName: item?.sections?.name ?? "-",
          purchased: item?.purchased ?? 0,
          remaining: remaining > 0 ? remaining : 0,
        });
      });
      let rem = maxInvites - inviteUsed;
      data[0].maxInvites = maxInvites;
      data[0].inviteUsed = inviteUsed;
      data[0].purchased = purchased;
      data[0].remaining = rem > 0 ? rem : 0;
      data[0].collection = collection;
      rows.push(data[0]);
    });
    return rows;
  }
}
